import React from 'react';
import styles from './index.module.scss';

const PoweredBy = () => (
  <div className={styles.poweredBy}>
    <span>Powered By</span>
    <a href="https://www.breezedeus.com/" target="_blank" rel="noopener noreferrer">
      Breezedeus
    </a>
  </div>
);

export default PoweredBy;
